import React, { useState, useEffect, useCallback } from 'react';

const AdditionalNotes = ({
  manualInputs,
  onSave,
  initialValues = {},
  dictionary = {},
}) => {
  const [inputValues, setInputValues] = useState({});
  const [editingField, setEditingField] = useState(null);

  // Initialize input values when manualInputs change
  useEffect(() => {
    if (manualInputs) {
      const initialInputValues = {};
      manualInputs.forEach((input) => {
        initialInputValues[input] = initialValues[input] || '';
      });
      setInputValues(initialInputValues);
    }
  }, [manualInputs, initialValues]);

  const handleInputChange = (inputId, value) => {
    setInputValues((prev) => ({
      ...prev,
      [inputId]: value,
    }));
  };

  const handleEdit = (inputId) => {
    setEditingField(inputId);
  };

  const handleSave = useCallback(
    (inputId) => {
      setEditingField(null);
      // Save the specific field that was edited
      if (onSave) {
        onSave(inputValues);
      }
    },
    [inputValues, onSave],
  );

  const handleKeyDown = (e, inputId) => {
    if (e.key === 'Enter') {
      handleSave(inputId);
    } else if (e.key === 'Escape') {
      setEditingField(null);
    }
  };

  const handleBlur = (e, inputId) => {
    // If the click is on the check icon or edit icon, let their handlers handle it
    if (
      e.relatedTarget &&
      (e.relatedTarget.classList.contains('check-icon') ||
        e.relatedTarget.classList.contains('edit-icon'))
    ) {
      return;
    }

    // Otherwise, save and exit editing mode
    handleSave(inputId);
  };

  // Handle clicks outside the component
  useEffect(() => {
    if (editingField !== null) {
      const handleClickOutside = (e) => {
        // If click is not on any element with note-field-value-wrapper class or its children
        if (!e.target.closest('.note-field-value-wrapper')) {
          handleSave(editingField);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [editingField, handleSave]);

  if (!manualInputs || manualInputs.length === 0) {
    return null;
  }

  return (
    <div className="additional-notes-container">
      <h3 className="additional-notes-title">Ek Girdiler</h3>
      {manualInputs.map((inputId) => (
        <div key={inputId} className="note-field-container">
          <div className="note-field-title">
            {dictionary[inputId] || inputId}
          </div>
          <div className="note-field-wrapper">
            {editingField === inputId ? (
              <div className="note-field-value-wrapper editing-wrapper">
                <input
                  type="text"
                  value={inputValues[inputId] || ''}
                  onChange={(e) => handleInputChange(inputId, e.target.value)}
                  onBlur={(e) => handleBlur(e, inputId)}
                  onKeyDown={(e) => handleKeyDown(e, inputId)}
                  autoFocus
                  className="note-field-input note-field-input-editing"
                />
                <button
                  className="check-icon"
                  onClick={() => handleSave(inputId)}
                  onBlur={(e) => handleBlur(e, inputId)}
                  aria-label="Save"
                  tabIndex="0"
                />
              </div>
            ) : (
              <div className="note-field-value-wrapper">
                <input
                  type="text"
                  value={inputValues[inputId] || ''}
                  readOnly
                  onClick={() => handleEdit(inputId)}
                  className="note-field-input"
                />
                <button
                  className="edit-icon"
                  onClick={() => handleEdit(inputId)}
                  aria-label="Edit"
                />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdditionalNotes;
